import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ModalComponent } from "./modal/modal.component";
import { SurveyStatusV2Service } from "../../survey-status-v2.service";
import * as XLSX from 'xlsx';
import * as backInter from 'app/auth/auth-data.model';
import { saveAs } from 'file-saver';
import { NuevoColaboradorComponent } from "./nuevo-colaborador/nuevo-colaborador.component";
import { lang_toolbar } from 'app/idiomas/i18n/toolbar/toolbar.lang';
const moment = require('moment');
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'colaboradores',
  templateUrl: './colaboradores.component.html',
  styleUrls: ['./colaboradores.component.scss'],
  animations   : fuseAnimations
})
export class ColaboradoresComponent implements OnInit {

  @Input() setStatusBoton: Observable<any>;
  @Input() infoEmpresaProducto: Observable<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  columnasResultado: string[] = ['nombre','correo','clave','status','inicio','fin','acciones'];
  resultados: MatTableDataSource<any>;

  categorias = [
    {
      nombre: 'Colaboradores',
      id: 'colaboradores',
      acciones: [
        { id: 'primerosColab', nombre: 'Ver primeros 1000', icono: 'people', bloqueado: true, funcion: 'primeros1000_paso1' },
        { id: 'buscarColab', nombre: 'Buscar colaborador', icono: 'search', bloqueado: true, funcion: 'buscarColaborador_paso1' },
        { id: 'nuevoColab', nombre: 'Agregar nuevo colaborador', icono: 'person_add', bloqueado: true, funcion: 'agregaColaborador' },
        { id: 'enviaReco', nombre: 'Enviar recordatorios', icono: 'email', bloqueado: true, funcion: 'enviaRecordatorios_paso1' },
        { id: 'bajarColab', nombre: 'Descargar lista de colaboradores', icono: 'get_app', bloqueado: true, funcion: 'descargarExcel_paso1' },
      ]
    },
  ];
  asuntos = [
    { nombre: 'Tipo de asunto 1', tipo: 1 },
    { nombre: 'Tipo de asunto 2', tipo: 2 },
    { nombre: 'Tipo de asunto 3', tipo: 3 },
    { nombre: 'Tipo de asunto 4', tipo: 4 },
  ]
  tipoAsuntoElgido: any;
  tipoIdiomaElgido: any;
  pasoColaboradores: any;
  datosEmpresaProducto: any = {};
  cargandoColaboradores: boolean;
  enviandoRecordatorios: boolean;

  bdPrueba = [];
  correosPrueba = [];
  cargaCorreos: boolean;
  idiomaActual: string;
  primLlamadaInfoTmpl: boolean; //tiene que existir para que solo se llame una vez, depende de un dato asincrono
  informacionTemplate: any;
  informacionTemplateSelect: any;
  colaboradorSeleccionado: any;
  idiomasTemplateEmail:any=[];
  offsetPipe: string;
  diferenciaUtc: number;
  constructor(
    private dialog: MatDialog,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private datePipe: DatePipe,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    lang_toolbar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.setStatusBoton.subscribe((datos:any) => {
      if (datos != null) {
        console.log("statusBoton:",datos);
        setTimeout(() => {
          this.categorias.forEach(categoria => {
            let boton = categoria.acciones.find(item => item.id == datos.id);
            if(boton != undefined){
              boton.bloqueado = datos.status;
            }
          });
        }, 1000);
      }
    });
    this.infoEmpresaProducto.subscribe((datos:any) => {
      console.log("datos=============================================================",datos);

      for(let prop in datos){
        this.datosEmpresaProducto[prop] = datos[prop];
        if(!this.informacionTemplate && this.datosEmpresaProducto.idProducto){
          this.obtener_infoTemplate();
        }
      }
    });
  }



  prro(){
    console.log("hola prro");

  }

  obtener_infoTemplate(){
    if(!this.primLlamadaInfoTmpl){
      this.primLlamadaInfoTmpl = true;
      let dataTemplate:any = { productoId: this.datosEmpresaProducto.idProducto };
      this.surveyServ.informacion_template(this.datosEmpresaProducto.idEmpresa, dataTemplate).subscribe( (data: any) => {
        console.log("Información template:",data);
        if(data.message== 'Success'){
          this.informacionTemplate=data.generalCorreos;
          this.informacionTemplateSelect=data.generalCorreos;
          this.informacionTemplate.forEach(lang => {
            if (this.idiomasTemplateEmail.length==0) {
              this.idiomasTemplateEmail.push({idioma:lang.idioma});
            }else{
              let idiomaEncontr= this.idiomasTemplateEmail.findIndex(item=>item.idioma == lang.idioma);
              if (idiomaEncontr==-1) {
                console.log('entroe');
                this.idiomasTemplateEmail.push({idioma:lang.idioma});
              }
            }
          });
          console.log('this.idiomasTemplateEmail',this.idiomasTemplateEmail);

        }
      });
    }
  }

  primeros1000_paso1(){
    this.resultados = null;
    this.cargandoColaboradores = true;
    let instituto = parseInt(localStorage.getItem('instituto_id'));
    let refProd = this.datosEmpresaProducto.datosProducto;
    console.log("refProd:",refProd);
    if(this.datosEmpresaProducto.tipoProducto == 3 ||this.datosEmpresaProducto.tipoProducto == 63){  //Si es norma 35
      this.surveyServ.desColaboradores(refProd.idSurveyMenos,refProd.idSurveyMas,4,instituto,refProd.tokenConfig).subscribe( (respuesta:any) => {
        this.primeros1000_paso2(respuesta,0);
      });
    } else{
      this.surveyServ.desColaboradores(refProd.idSurvey,0,3,instituto,refProd.tokenConfig).subscribe( (respuesta:any) => {
        this.primeros1000_paso2(respuesta,0);
      });
    }
  }
  primeros1000_paso2(datos:any,idStatus:number){
    let arregloOrdenado = datos.result.sort((a,b) => a.name.localeCompare(b.name));
    let listaCustomId = [];
    if(idStatus > 0){
      arregloOrdenado.forEach(usuario => {
        if(usuario.id_status == idStatus){
          listaCustomId.push(usuario);
        }
      });
    }
    this.bdPrueba = listaCustomId.length > 0 ? listaCustomId : arregloOrdenado;
    if(this.datosEmpresaProducto.tipoProducto == 52){   //si es el producto cgo express le deshabilita el boton de correos
      this.bdPrueba.forEach(colaborador => {
        colaborador.sinCorreos = true;
      });
    }
    this.resultados = new MatTableDataSource<any>(this.bdPrueba);
    setTimeout(() => this.resultados.paginator = this.paginator);
    this.cargandoColaboradores = false;

    // setTimeout(() => this.paginator._intl.getRangeLabel=(page: number, pageSize: number, length: number) => { if (length == 0 || pageSize == 0)
    //   { return `0 ${label2} ${length}`; } length = Math.max(length, 0); const startIndex = page * pageSize;
    //   const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    //   return `${startIndex + 1} – ${endIndex} ${label2} ${length}`; });
    //
    //   this.dataSource_nuevo.filterPredicate = (data, filterValue: string)  => {
    //     const accumulator = (currentTerm, key) => {
    //       return key === 'doctores' ? currentTerm : currentTerm + data[key];
    //     };
    //     const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
    //     // Transform the filterValue by converting it to lowercase and removing whitespace.
    //     const transformedFilter = filterValue.trim().toLowerCase();
    //     return dataStr.indexOf(transformedFilter) !== -1;
    //   };

  }

  buscarColaborador_paso1(){
    Swal.fire({
      title: this.translateSrv.instant('COLABORADORES.MODALES.BUSCAR'),
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('COLABORADORES.MODALES.BUSCAR_BOT'),
      showLoaderOnConfirm: true,

      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        console.log("A buscar:",result.value);
        this.buscarColaborador_paso2(result.value);
      }
    })
  }

  buscarColaborador_paso2(nombre:string){
    let params = {
      param1: null,
      param2: 0,
      param3: 1,
      param4: nombre,
      param5:null
    };
    switch (this.datosEmpresaProducto.tipoProducto) {
      case 3: //nom35
        params.param1 = this.datosEmpresaProducto.datosProducto.idSurveyMenos;
        params.param2 = this.datosEmpresaProducto.datosProducto.idSurveyMas;
        params.param3 = 4;
        params.param5 = this.datosEmpresaProducto.datosProducto.tokenConfig;
      break;
      case 63: //nom35
        params.param1 = this.datosEmpresaProducto.datosProducto.idSurveyMenos;
        params.param2 = this.datosEmpresaProducto.datosProducto.idSurveyMas;
        params.param3 = 4;
        params.param5 = this.datosEmpresaProducto.datosProducto.tokenConfig;
      break;
      // case 43: //focus area
      // console.log('sdkks',this.datosEmpresaProducto);
      //
      //   params.param1 = this.datosEmpresaProducto.datosProducto.tokenConfig;  //dato pendiente
      // break;
      default:  //resto de productos
        params.param1 = this.datosEmpresaProducto.datosProducto.idSurvey;
        params.param5 = this.datosEmpresaProducto.datosProducto.tokenConfig;

      break;
    }
    this.surveyServ.desColaboradoresV2(params.param1, params.param2, params.param3, params.param4,params.param5).subscribe( (data : any) => {
      this.primeros1000_paso2(data,0);
    }, error  => {
      console.log("error");
    });
  }

  agregaColaborador(){
    let refProd = this.datosEmpresaProducto.datosProducto;
    const dialogRef = this.dialog.open(NuevoColaboradorComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: {
        SurveyId: refProd.tokenMas50 != undefined ? refProd.tokenMas50 : [refProd.tokenMenos50 != undefined ? refProd.tokenMenos50 : refProd.idSurvey],
        idEmpresa: this.datosEmpresaProducto.idEmpresa,
        idSurveyMas: refProd.idSurveyMas,
        idSurveyMenos: refProd.idSurveyMenos,
        idProducto: this.datosEmpresaProducto.idProducto,
        tipoProducto: this.datosEmpresaProducto.tipoProducto
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        console.log("resultado:",result);
        if(result == true){ //recuperar nuevamente los 1000 primeros
          this.primeros1000_paso1();
        }
      }
    });
  }

  enviaRecordatorios_paso1(){
    if(!this.enviandoRecordatorios){
      this.enviandoRecordatorios = true;
      let {tipoProducto} = this.datosEmpresaProducto;
      switch (tipoProducto) {
        // case 3: break;  //norma 35
        case 4: //pulse check 1.0
          this.enviaRecordatorios_paso2_pulse();
        break;
        case 2: case 11: case 12: case 13: case 14: case 15: case 16:  //medires
          this.enviaRecordatorios_paso2_medir();
        break;
        default:  //resto de productos
        if(tipoProducto == 1){
          this.enviaRecordatorios_paso2_certificar(1);
        } else if(tipoProducto == 2 ||  tipoProducto == 3){
          this.enviaRecordatorios_paso2_certificar(2);
        } else{
          this.enviaRecordatorios_paso2_certificar(3);
        }
        break;
      }
    }
  }
  enviaRecordatorios_paso2_certificar(tipo:number){
    let texto = this.translateSrv.instant('CIERRE.ALERT_RE.MESSAGE');
    let rspSi = this.translateSrv.instant('CIERRE.ALERT_RE.BTN_CONFIRM');
    let rspNo = this.translateSrv.instant('CIERRE.ALERT_RE.BTN_CANCEL');
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {

        if(this.datosEmpresaProducto.fechaLanzamiento){
          if(moment().isAfter(moment(this.datosEmpresaProducto.fechaLanzamiento))){
            let datos = { productoId: this.datosEmpresaProducto.idProducto };
            Swal.fire({
              title: this.translateSrv.instant('CIERRE.CARGANDOCORREO'),
              didOpen: () => {
                Swal.showLoading()
              }
            });
            this.surveyServ.getRecordatorios_correo_statussurvey(datos,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
              let estatusEnvioRecos: boolean;
              if(data.recordatoriosManuales.length == 0){
                estatusEnvioRecos = true;
              } else{
                let fechaUltimoReco = moment(data.recordatoriosManuales[data.recordatoriosManuales.length - 1].fechaRecordatorio);
                if(moment().isAfter(fechaUltimoReco)){
                  estatusEnvioRecos = true;
                }
              }

              if(estatusEnvioRecos == true){  //si se pueden enviar recordatorios
                ///TIPO 1
                if(tipo == 1){
                  this.surveyServ.CertificarsendRecordatorio_statusSurvey(datos.productoId,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
                    this.enviandoRecordatorios = false;
                    Swal.fire({
                      title: this.translateSrv.instant('CIERRE.LABEL5'),
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });
                  },error=>{
                    console.log(error);
                  });
                }

                ///TIPO 2
                if(tipo == 2){
                  this.surveyServ.CertificarsendRecordatorio_statusSurveySMTP(datos.productoId,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
                    this.enviandoRecordatorios = false;
                    Swal.fire({
                      title: this.translateSrv.instant('CIERRE.LABEL5'),
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });
                  });
                }

                ///TIPO 3
                if(tipo == 3){
                  this.surveyServ.Certificar3sendRecordatorio_statusSurveySMTP(datos.productoId,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
                    this.enviandoRecordatorios = false;
                    Swal.fire({
                      title: this.translateSrv.instant('CIERRE.LABEL5'),
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });
                  });
                }
              } else{ //si no se pueden enviar recordatorios
                Swal.fire({
                  title: this.translateSrv.instant('CIERRE.LABEL6'),
                  icon: "error",
                  confirmButtonColor: '#e40601'
                });
              }
            });
          } else{
            Swal.fire({
              title: this.translateSrv.instant('COLABORADORES.MODALES.MINIMARECO'),
              icon: "error",
              confirmButtonColor: '#e40601'
            });
          }
        }
      }
      this.enviandoRecordatorios = false;
    });
  }
  enviaRecordatorios_paso2_medir(){
    let texto = this.translateSrv.instant('CIERRE.ALERT_RE.MESSAGE');
    let rspSi = this.translateSrv.instant('CIERRE.ALERT_RE.BTN_CONFIRM');
    let rspNo = this.translateSrv.instant('CIERRE.ALERT_RE.BTN_CANCEL');
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {

        if(this.datosEmpresaProducto.fechaLanzamiento){
          if(moment().isAfter(moment(this.datosEmpresaProducto.fechaLanzamiento))){
            let datos = { productoId: this.datosEmpresaProducto.idProducto };
            Swal.fire({
              title: this.translateSrv.instant('CIERRE.CARGANDOCORREO'),
              didOpen: () => {
                Swal.showLoading()
              }
            });
            this.surveyServ.getRecordatorios_correoGenerico_status(datos,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
              let estatusEnvioRecos: boolean;
              if(data.recordatoriosManuales.length == 0){
                estatusEnvioRecos = true;
              } else{
                let fechaUltimoReco = moment(data.recordatoriosManuales[data.recordatoriosManuales.length - 1].fechaRecordatorio);
                if(fechaUltimoReco){
                  if(moment().isAfter(fechaUltimoReco)){
                    estatusEnvioRecos = true;
                  }
                } else{
                  estatusEnvioRecos = true;
                }
              }

              if(estatusEnvioRecos == true){  //si se pueden enviar recordatorios
                this.surveyServ.sendRecordatorioMedirGenerico_status(datos.productoId,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
                  this.enviandoRecordatorios = false;
                  Swal.fire({
                    title: this.translateSrv.instant('CIERRE.LABEL5'),
                    icon: "success",
                    confirmButtonColor: '#e40601'
                  });
                },error=>{
                  console.log(error);
                });
              } else{ //si no se pueden enviar recordatorios
                Swal.fire({
                  title: this.translateSrv.instant('CIERRE.LABEL6'),
                  icon: "error",
                  confirmButtonColor: '#e40601'
                });
              }
            });
          } else{
            Swal.fire({
              title: this.translateSrv.instant('COLABORADORES.MODALES.MINIMARECO'),
              icon: "error",
              confirmButtonColor: '#e40601'
            });
          }
        }
      }
      this.enviandoRecordatorios = false;
    });
  }
  enviaRecordatorios_paso2_pulse(){
    let texto = this.translateSrv.instant('CIERRE.ALERT_RE.MESSAGE');
    let rspSi = this.translateSrv.instant('CIERRE.ALERT_RE.BTN_CONFIRM');
    let rspNo = this.translateSrv.instant('CIERRE.ALERT_RE.BTN_CANCEL');
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {

        if(this.datosEmpresaProducto.fechaLanzamiento){
          if(moment().isAfter(moment(this.datosEmpresaProducto.fechaLanzamiento))){
            let datos = { productoId: this.datosEmpresaProducto.idProducto };
            Swal.fire({
              title: this.translateSrv.instant('CIERRE.CARGANDOCORREO'),
              didOpen: () => {
                Swal.showLoading()
              }
            });
            this.surveyServ.getRecordatoriosPulse_status(datos,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
              let estatusEnvioRecos: boolean;
              if(data.recordatoriosManuales.length == 0){
                estatusEnvioRecos = true;
              } else{
                let fechaUltimoReco = moment(data.recordatoriosManuales[data.recordatoriosManuales.length - 1].fechaRecordatorio);
                if(moment().isAfter(fechaUltimoReco)){
                  estatusEnvioRecos = true;
                }
              }

              if(estatusEnvioRecos == true){  //si se pueden enviar recordatorios
                let datosPulse:any = { productoId:this.datosEmpresaProducto.idProducto, numeroFecha: 1 };
                this.surveyServ.sendRecordatoriosPulse_status(datosPulse.productoId,this.datosEmpresaProducto.idEmpresa).subscribe( (data: any) => {
                  this.enviandoRecordatorios = false;
                  Swal.fire({
                    title: this.translateSrv.instant('CIERRE.LABEL5'),
                    icon: "success",
                    confirmButtonColor: '#e40601'
                  });
                },error=>{
                  console.log(error);
                });
              } else{ //si no se pueden enviar recordatorios
                Swal.fire({
                  title: this.translateSrv.instant('CIERRE.LABEL6'),
                  icon: "error",
                  confirmButtonColor: '#e40601'
                });
              }
            });
          } else{
            Swal.fire({
              title: this.translateSrv.instant('COLABORADORES.MODALES.MINIMARECO'),
              icon: "error",
              confirmButtonColor: '#e40601'
            });
          }
        }
      }
      this.enviandoRecordatorios = false;
    });
  }

  descargarExcel_paso1(){
    // let mensaje = this.translateSrv.instant('AAAA.AAAA');
    Swal.fire({
      title: this.translateSrv.instant('COLABORADORES.MODALES.GENERAEXCEL'),
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let params = {
      param1: null,
      param2: 0,
      param3: 1,
      param4: parseInt(localStorage.getItem('instituto_id')),
      param5:null,
    };
    switch (this.datosEmpresaProducto.tipoProducto) {
      case 3: //nom35
        params.param1 = this.datosEmpresaProducto.datosProducto.idSurveyMenos;
        params.param2 = this.datosEmpresaProducto.datosProducto.idSurveyMas;
        params.param3 = 2;
        params.param5 = this.datosEmpresaProducto.datosProducto.tokenConfig;
      break;
      case 63: //nom35v3
        params.param1 = this.datosEmpresaProducto.datosProducto.idSurveyMenos;
        params.param2 = this.datosEmpresaProducto.datosProducto.idSurveyMas;
        params.param3 = 2;
        params.param5 = this.datosEmpresaProducto.datosProducto.tokenConfig;
      break;
      // case 43: //focus area
      //   params.param1 = this.datosEmpresaProducto.idFocus_config;  //dato pendiente
      // break;
      default:  //resto de productos
        params.param1 = this.datosEmpresaProducto.datosProducto.idSurvey;
        params.param5 = this.datosEmpresaProducto.datosProducto.tokenConfig;
      break;
    }
    this.surveyServ.desColaboradores(params.param1, params.param2, params.param3, params.param4, params.param5).subscribe( (respuesta:any) => {
      console.log("desColaboradores:",respuesta);
      // this.listaUsuarios = respuesta.result;
      this.descargarExcel_paso2(respuesta.result);
    });
  }
  descargarExcel_paso2(listaColaboradores:any){
    listaColaboradores.forEach(colaborador => {
      if(colaborador.start_date == null){
        colaborador.start_date = 'N/A';
      }
      if(colaborador.end_date == null){
        colaborador.end_date = 'N/A';
      }
      if(colaborador.id_status){
        switch (colaborador.id_status){
          case 1:
            colaborador.id_status = this.translateSrv.instant("AVANCES.TITULOS.ESTADOS_ENC.ESTADO1");
          break;
          case 2:
            colaborador.id_status = this.translateSrv.instant("AVANCES.TITULOS.ESTADOS_ENC.ESTADO1");
          break;
          case 3:
            colaborador.id_status = this.translateSrv.instant("AVANCES.TITULOS.ESTADOS_ENC.ESTADO3");
          break;
          case 4:
            colaborador.id_status = this.translateSrv.instant("AVANCES.TITULOS.ESTADOS_ENC.ESTADO4");
          break;
        }
      } else{
        colaborador.id_status = "N/A";
      }
    });
    this.descargarExcel_paso3(listaColaboradores);
  }
  descargarExcel_paso3(listaColaboradores:any){
    console.log('this.datosEmpresaProducto.offsetPipe',this.datosEmpresaProducto.offsetPipe);


    // Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO"),
      Subject: 'CULTURAL GO',
      Author: 'ITBM',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];
    backInter.CLAVES_COLUMNASPRODUCTOS.forEach( (nombre) => {
      switch(nombre){
        // case 'name': nombresColumnas.push(this.mensajesTraducirTS.columna4); break;
        // case 'email': nombresColumnas.push(this.mensajesTraducirTS.columna1); break
        // case 'id_status': nombresColumnas.push(this.mensajesTraducirTS.columna3); break;
        // case 'start_date': nombresColumnas.push(this.mensajesTraducirTS.columna5); break;
        // case 'end_date': nombresColumnas.push(this.mensajesTraducirTS.columna2); break;
        case 'name': nombresColumnas.push(this.translateSrv.instant("COLABORADORES.EXCEL.COLUMNAS.name")); break;
        case 'email': nombresColumnas.push(this.translateSrv.instant("COLABORADORES.EXCEL.COLUMNAS.email")); break;
        case 'id_status': nombresColumnas.push(this.translateSrv.instant("COLABORADORES.EXCEL.COLUMNAS.id_status")); break;
        case 'start_date': nombresColumnas.push(this.translateSrv.instant("COLABORADORES.EXCEL.COLUMNAS.start_date")); break;
        case 'end_date': nombresColumnas.push(this.translateSrv.instant("COLABORADORES.EXCEL.COLUMNAS.end_date")); break;
      }
    });
    //console.log("Colaboradores")
    ws_data.push(nombresColumnas);
    listaColaboradores.forEach( (colaborador) => {
      let datosColaboradores:any[] = [];
      backInter.CLAVES_COLUMNASPRODUCTOS.forEach( (nombre) => {
        switch(nombre){
          case 'name': datosColaboradores.push(colaborador.name); break;
          case 'email': datosColaboradores.push(colaborador.email); break;
          case 'id_status': datosColaboradores.push(colaborador.id_status); break;
          case 'start_date':
          if(colaborador.start_date!="N/A") {
            datosColaboradores.push(this.datePipe.transform(new Date(colaborador.start_date),'dd MMM YYYY HH:mm:ss',this.datosEmpresaProducto.offsetPipe,this.idiomaActual));
          }else{
            datosColaboradores.push(colaborador.start_date);
          }
          break;
          // case 'start_date': datosColaboradores.push(colaborador.start_date); break;
          case 'end_date':

          if(colaborador.end_date!="N/A") {
            datosColaboradores.push(this.datePipe.transform(new Date(colaborador.end_date),'dd MMM YYYY HH:mm:ss',this.datosEmpresaProducto.offsetPipe,this.idiomaActual));
          }else{
            datosColaboradores.push(colaborador.end_date);
          }
          break;
        }
      });
      ws_data.push(datosColaboradores);
      // console.log(ws_data);
    });
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets['hoja'] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    // saveAs(new Blob([buf],{type:"application/octet-stream"}),this.product_name+' '+this.mensajesTraducirTS.columna6+' - '+this.nombreEmpresa+'.xlsx');
    saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
    Swal.close();
  }

  accionesUsuario(datosColab: any){
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '50%',
      disableClose: true,
      data: {
        datosEmpresaProducto: this.datosEmpresaProducto,
        datosColab
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("resultado:",result);
      if(result != undefined){
        if(result == 2){  //recuperar 1000 colaboradores
          this.primeros1000_paso1();
        }
      }
    });
  }

  verCorreos(datosColaborador:any){
    this.pasoColaboradores = 1;
    this.colaboradorSeleccionado = datosColaborador;
    this.cargaCorreos = false;
    this.correosPrueba = null;
    this.tipoAsuntoElgido = null;
    this.tipoIdiomaElgido = null;
  }

  // eligeIdiomaLog(event:any){
  //   console.log('event',event);
  //
  //   this.informacionTemplate.forEach(emailAsun => {
  //   if (emailAsun.idioma==this.tipoIdiomaElgido.idioma) {
  //     this.informacionTemplateSelect.push(emailAsun);
  //   }
  //   });
  //   console.log("tipoElegido:",this.tipoIdiomaElgido);
  //   console.log("informacionTemplateSelect:",this.informacionTemplateSelect);
  //
  // }
  eligeAsuntoLog(){
    console.log("tipoElegido:",this.tipoAsuntoElgido);
    let cargando = this.translateSrv.instant('MODALES.LOG_SENDGRIND.CARGANDO');
    let mensaje = this.translateSrv.instant('MODALES.LOG_SENDGRIND.ASUNTO');
    let cerrar = this.translateSrv.instant('MODALES.LOG_SENDGRIND.CONFIRMAR');

    // if(this.Valorasunto){
      // this.historial=[];
      // this.correo=this.dataEmail.email;
      Swal.fire({
        title: cargando,
        didOpen: () => {
          Swal.showLoading()
        }
      });
      this.surveyServ.getStatusEmail(this.colaboradorSeleccionado.email,this.tipoAsuntoElgido.asunto).subscribe( (data: any) => {
        console.log("getStatusEmail:",data);
        if(data.success){
          this.correosPrueba = data.log.messages;
        }
        this.cargaCorreos = true;
        Swal.close();
      });
  }

  copiarURL(url: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: this.translateSrv.instant('ACCIONES.MODALES.URL'),

      confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    });

  }


}
